import React from 'react'
import FormLabel from '@/components/ui/FormLabel'
import Input from '@/components/ui/Input'
import { InputProps } from '@/components/ui/Input/Input'
import { useField } from 'formik'
import FormHelperText from '@/components/ui/FormHelperText'

export type FormikInputProps = {
  name: string
  label: string
  description?: React.ReactElement | string
} & InputProps

const FormikInput = ({ label, className, description, ...props }: FormikInputProps) => {
  const [field, { error, touched }] = useField(props.name)
  const isError = error && touched
  const color = isError ? 'danger' : undefined
  const shouldDisplayHint = isError || description

  return (
    <div className={className}>
      <FormLabel>{label}</FormLabel>
      <Input color={color} {...field} {...props} />
      {shouldDisplayHint && <FormHelperText color={color}>{isError ? error : description}</FormHelperText>}
    </div>
  )
}

export default FormikInput
